<img src="../../../assets/images/check-green.gif">
<div class="align">
    <h1 style="color: rgb(3, 207, 3);">Transaction has been cancelled successfully</h1>
</div>

<div class="buttonRow">
    <!-- <button mat-raised-button class="button" type="button" (click)="onNoClick()" (click)="onClick()">
        View payment link</button> -->
    <button mat-raised-button class="buttonReset" type="button" (click)="onNoClick()"
        style="margin-left: 10px;">Close</button>
</div>